import type { FC } from 'react'

import type { TIconProps } from 'types'

const CloseHeaderIcon: FC<TIconProps> = ({ className }) => (
  <svg className={className} width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M16.0013 29.3337C23.3346 29.3337 29.3346 23.3337 29.3346 16.0003C29.3346 8.66699 23.3346 2.66699 16.0013 2.66699C8.66797 2.66699 2.66797 8.66699 2.66797 16.0003C2.66797 23.3337 8.66797 29.3337 16.0013 29.3337Z'
      stroke='#1D1D1D'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M12.2266 19.7732L19.7732 12.2266'
      stroke='#1D1D1D'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M19.7732 19.7732L12.2266 12.2266'
      stroke='#1D1D1D'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export default CloseHeaderIcon
